import { make } from 'vuex-pathify';
import { DelinquencyCaseAssignmentService } from '../services/delinquency-case-assignment.service.js';
import Logger from '@/lib/logger.js';

const service = new DelinquencyCaseAssignmentService();

const state = {
  participantCases: [],
  participantCaseReport: {},
  participantLoanCases: [],
  participantChargedOffCaseReport: []
};

const mutations = make.mutations(state);

const actions = {
  async updateDelinquencyCaseAssignment(_, { id, data }) {
    try {
      const { data: res } = await service.updateDelinquencyCaseAssignment(id, data );
      return res;
    } catch (error) {
      Logger.error('Updating Delinquency Collateral Assignment');
      throw error;
    }
  },

  async unAssignExternalCaseAssignments(_, ids) {
    try {
      const { data } = await service.unAssignExternalCaseAssignments(ids);
      return data;
    } catch (error) {
      Logger.error('Un-assigning Delinquency Collateral Assignment');
      throw error;
    }
  },

  async findExternalCaseAssignments(_, filters) {
    try {
      const { data } = await service.findExternalCaseAssignments(filters?.externalParticipantId, filters?.page, filters?.limit, filters?.sort, filters?.order);
      return data;
    } catch (error) {
      Logger.error( 'Finding Delinquency Case Assignment');
      throw error;
    }
  },

  async assignExternalCase(_, payload) {
    try {
      const { data: res } = await service.assignExternalCase(payload);
      return res;
    } catch (error) {
      Logger.error('Assigning Delinquency Case Assignment');
      throw error;
    }
  },

  async fetchExternalCaseAssignmentReport({commit}, externalParticipantId) {
    try {
      const { data } = await service.fetchExternalCaseAssignmentReport(externalParticipantId);
      commit('SET_PARTICIPANT_CASE_REPORT', data);
      return data;
    } catch (error) {
      Logger.error('Finding Delinquency Case Assignment Report');
      throw error;
    }
  },

  async fetchChargedOffLoanExternalCaseAssignmentReport({commit}, externalParticipantId) {
    try {
      const { data } = await service.fetchChargedOffLoanExternalCaseAssignmentReport(externalParticipantId);
      commit('SET_PARTICIPANT_CHARGED_OFF_CASE_REPORT', data);
      return data;
    } catch (error) {
      Logger.error('Finding Delinquency Case Assignment Report');
      throw error;
    }
  },

  async fetchLoanCases({commit}, pagination) {
    try {
      const { data } = await service.fetchLoanCases(pagination?.page, pagination?.limit);
      commit('SET_PARTICIPANT_LOAN_CASES', data);
      return data;
    } catch (error) {
      Logger.error('Finding Delinquency Case Assignment Report');
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions
};